import { Utils } from '@lightningjs/sdk'

export const fixPngImageTransparency = (url: string) => {
  return url + '?.png'
}

export const getAsset = (relativePath: string) => {
  return Utils.asset(relativePath)
}

export const getIcon = (icon: string) => {
  return Utils.asset(`icons/${icon}.svg`)
}
